var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDinersSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "SVGInline-svg SVGInline--cleaned-svg SVG-svg BrandIcon-svg BrandIcon--size--32-svg",
    height: 32,
    width: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z",
    fill: "#ebf1f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.319 8.021V8h5.263v.021C22.707 8.327 25.9 11.808 25.9 16s-3.193 7.673-7.318 7.979V24h-5.263v-.021C9.193 23.673 6 20.192 6 16s3.193-7.673 7.319-7.979z",
    fill: "#0165ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.474 20.523c1.888-.68 3.15-2.492 3.15-4.523s-1.262-3.842-3.15-4.523zm-3.158-9.046c-1.889.68-3.15 2.492-3.15 4.523s1.261 3.842 3.15 4.523zm1.579 11.456c-3.78 0-6.842-3.104-6.842-6.933 0-3.83 3.063-6.933 6.842-6.933 3.779 0 6.842 3.104 6.842 6.933 0 3.83-3.063 6.933-6.842 6.933z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersSquare);
export default __webpack_public_path__ + "static/media/diners-square.eed935152e59cc2b1bb7b7878316426a.svg";
export { ForwardRef as ReactComponent };